/**
 * Lightweight logger that is silent in production builds.
 *
 * Replaces direct console.log/warn/error calls scattered across the app
 * (~48 call sites) so that diagnostic output doesn't leak into the
 * production console, while keeping it available during development.
 * `logger.error` still reports in production via onError if provided,
 * which keeps a hook for wiring up real error reporting later.
 */

const isDev = process.env.NODE_ENV !== 'production';

type OnError = (message: string, ...args: any[]) => void;

let onErrorHandler: OnError | null = null;

export function setErrorReporter(handler: OnError | null): void {
  onErrorHandler = handler;
}

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },
  error: (message: string, ...args: any[]) => {
    if (isDev) console.error(message, ...args);
    if (onErrorHandler) {
      try {
        onErrorHandler(message, ...args);
      } catch {
        // never let logging itself throw
      }
    }
  },
};
